import AppProvider from 'contexts/app';
import AppBarProvider from 'contexts/appBar';
import DialogProvider from 'contexts/dialog';
import JoyrideProvider from 'contexts/joyride';
import NavigationGuardProvider from 'contexts/navigationGuard';
import ViewportProvider from 'contexts/viewport';
import WebsocketProvider from 'contexts/websocket';

const ProviderWrapper = ({ children }) => {
    return (
        <ViewportProvider>
            <AppBarProvider>
                <DialogProvider>
                    <NavigationGuardProvider>
                        <WebsocketProvider>
                            <AppProvider>
                                <JoyrideProvider>{children}</JoyrideProvider>
                            </AppProvider>
                        </WebsocketProvider>
                    </NavigationGuardProvider>
                </DialogProvider>
            </AppBarProvider>
        </ViewportProvider>
    );
};

export default ProviderWrapper;
